module.exports = __webpack_public_path__ + "img/chat-agent-box-229x162.928858a7.png";